import RequestPasswordReset from './RequestPasswordReset';

export default RequestPasswordReset;
